/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       CollaborationsScreen.tsx
 * @author     Christian Ascone
 * @date       3/2/20 4:25 PM
 */

import React, {Component} from 'react';
import {RefreshControl, ScrollView, View,} from 'react-native';
import {i18n} from "@i18n/i18n";
import collaborationsScreenStyle from "@styles/host/collaborations/CollaborationsScreenStyle";
import globalScreenStyle from "@styles/GlobalStyle";
import {default as Loader, LoaderState} from "@helpers/LoaderHelper";
import {NavigationProps, openIntroCollaboration, openCollaborationFiltersModal} from "@helpers/NavigationHelper";
import {AddButton} from "@components/AddButton";
import {
    getHouseFromNavigationProps,
    getUserFromNavigationProps,
    setHeaderTitleLocalized
} from "@helpers/NavigationDataHelper";
import {HostCollaboration, House, CollaborationFilterInput, User} from "@services/src/models";
import {HostHousesApi, HostCollaborationsApi} from "@services/src/apis";
import {Logger} from "@helpers/Logger";
import {DebugButton} from "@components/DebugButton";
import {NoDataLabel} from "@components/NoDataLabel";
import {FiltersClickableBlock} from "@components/ClickableBlock";
import {HouseSelection, HouseSelectionBean} from "../../../models/beans/HouseSelection";
import {CollaborationRow} from "@components/rows/CollaborationRow";

import {FilterHelper} from "@helpers/FilterHelper";
import {HostReservationFactory} from "../../../models/factory/HostReservationFactory";
import {HostCollaborationFactory} from "../../../models/factory/HostCollaborationFactory";

interface State extends LoaderState {
    house: House,
    houseSelectionBeans: Array<HouseSelectionBean>,
    user: User,
    collaborations: Array<HostCollaboration>,
    filters: CollaborationFilterInput,
    filters_count: number,
}

export default class CollaborationsScreen extends Component<NavigationProps, State> {
    static navigationOptions = {};
    didFocusListener: any;

    constructor(props) {
        super(props);
        setHeaderTitleLocalized(props, 'screens.collaborations.title');

        this.state = {
            house: getHouseFromNavigationProps(this),
            houseSelectionBeans: [],
            loading: false,
            user: getUserFromNavigationProps(this),
            collaborations: [],
            filters: {
                registryEmail: '',
            },
            filters_count: 0,
            refreshing: false,
        };
    }

    componentDidMount() {
        this.getAllCollaborations();

        this.didFocusListener = this.props.navigation.addListener('didFocus', payload => {
            this.getCollaborations();
        });
    }

    componentWillUnmount(): void {
        this.didFocusListener.remove();
    }

    render() {
        return (
            <View style={[collaborationsScreenStyle.container]}>
                <DebugButton onPress={() => debugUpdateData(this)}/>
                <Loader state={this.state}/>
                <View style={[collaborationsScreenStyle.container, globalScreenStyle.globalMargins]}>
                    {/*{this.state.house != null &&*/}
                    {/*<View>*/}
                    {/*<AvenirMediumPrimaryHalfOpacityText style={{textAlign: 'center'}}>*/}
                    {/*{this.state.house.name}*/}
                    {/*</AvenirMediumPrimaryHalfOpacityText>*/}
                    {/*</View>*/}
                    {/*}*/}
                    <View>
                        <FiltersClickableBlock
                            onPress={() => openCollaborationFiltersModal(this, this.state.filters, (filters) => this.applyFilters(filters), this.state.houseSelectionBeans)}
                            title={this.state.filters_count > 0 ? i18n.t('screens.collaborations.filters_with_count', {count: this.state.filters_count}) : i18n.t('screens.collaborations.filters')}
                            style={{marginVertical: 10, width: '40%', alignSelf: 'center',}}/>
                    </View>
                    <View style={globalScreenStyle.scrollContainerWithBottomButton}>
                        <ScrollView
                            style={[collaborationsScreenStyle.container]}
                            contentContainerStyle={[collaborationsScreenStyle.contentContainer]}
                            refreshControl={
                                <RefreshControl refreshing={this.state.refreshing}
                                                onRefresh={() => this.getCollaborations()}/>
                            }>
                            {this.state.collaborations.map((collaboration, key) => (
                                <View
                                    key={key}
                                    style={[collaborationsScreenStyle.doorContainer]}>
                                    <CollaborationRow context={this}
                                                    collaboration={collaboration} onDismiss={() => this.getCollaborations()}
                                                    houses={getHouseFromNavigationProps(this)}
                                    />
                                </View>
                            ))}

                        </ScrollView>
                        <NoDataLabel list={this.state.collaborations} show={this.state.showNoData}/>
                    </View>
                    <View style={[{position: 'absolute', bottom: 20}]}>
                        <AddButton title={i18n.t('screens.collaborations.add_button')}
                                   onPress={() => openIntroCollaboration(this)}/>
                    </View>
                </View>
            </View>
        );
    }

    applyFilters(filters: CollaborationFilterInput) {
        console.log(filters);
        this.setState({filters: filters, filters_count: FilterHelper.countCollaborationsFilters(filters)}, () => {
            this.getCollaborations();
        });
    }

    private getCollaborations() {
        if (this.state.filters_count == 0)
            this.getAllCollaborations();
        else
            this.getCollaborationsByFilters();
    }

    private getAllCollaborations() {
        let self = this;
        new HostCollaborationsApi(this).apiHostCollaborationsGet().then(resp => {
            Logger.log(self.constructor.name, `Found ${resp.data.length} collaborations for host.`);
            self.setState({collaborations: resp.data, showNoData: true});

            self.getHouses();
        }).catch(error => {
            Logger.warn(self.constructor.name, "Error " + error);
            self.setState({showNoData: true,});
        });
    }

    private getCollaborationsByFilters() {
        let self = this;
        Logger.log(self.constructor.name, `Calling with filters: ${JSON.stringify(this.state.filters)}`);
        new HostCollaborationsApi(this).apiHostCollaborationsByFiltersPost({collaborationFilterInput: this.state.filters}).then(resp => {
            Logger.log(self.constructor.name, `Found ${resp.data.length} collaborations by filters for host.`);
            self.setState({collaborations: resp.data, showNoData: true});
        }).catch(error => {
            Logger.warn(self.constructor.name, "Error " + error);
            self.setState({showNoData: true,});
        });
    }

    private getHouses() {
        let self = this;
        new HostHousesApi(this).apiHostHousesGet().then(resp => {
            Logger.log(self.constructor.name, `Found ${resp.data.length} resources for host.`);
            self.setState({houseSelectionBeans: HouseSelection.fromHouseList(resp.data)});
        }).catch(error => {
            Logger.warn(self.constructor.name, "Error " + error);
        });
    }


}

function debugUpdateData(context: Component<any, State>) {
    context.setState({collaborations: HostCollaborationFactory.factoryArray(15)});
}